import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../app/hooks"
import { loadDocumentForms, loadFormDefinitions } from "./formSectionApi"
import { selectDocumentFormsState, selectFormDefinitionsState } from "./formSectionSlice"

/** Loads the document's FORM sections once per opening of the document; every FORM section shares it. */
export const useDocumentForms = (documentId: string | number) => {
    const dispatch = useAppDispatch()
    const state = useAppSelector(s => selectDocumentFormsState(s, documentId))

    useEffect(() => {
        if (state === 'empty') dispatch(loadDocumentForms(documentId))
    }, [dispatch, documentId, state])

    return state
}

/**
 * Refetches the library on every mount: another admin may have published or archived something.
 * An admin gets every definition, anyone else only the published ones.
 */
export const useFormDefinitions = () => {
    const dispatch = useAppDispatch()
    const state = useAppSelector(selectFormDefinitionsState)

    useEffect(() => {
        dispatch(loadFormDefinitions())
    }, [dispatch])

    return state
}
